// Lightweight global context for the WhatsApp bubble deep-link message
let currentContext = null;

export const setWhatsAppContext = (text) => {
  currentContext = text || null;
  window.dispatchEvent(new Event("whatsapp-context-change"));
};

export const getWhatsAppContext = () => currentContext;
